/**
 * 懒块加载骨架（21w）。壳组件用它占位，块到了只是灰块换成内容，**版式不跳**。
 * 文件头的取舍（为什么是呼吸不是扫光）写在 skeleton.module.scss。
 */
import styles from './skeleton.module.scss';

function Block({ w, h, round }: { w: string; h: number; round?: boolean }) {
  return (
    <span
      className={round === true ? styles.circle : styles.block}
      style={{ width: w, height: `${h}px` }}
    />
  );
}

function Row({ icon }: { icon: boolean }) {
  return (
    <span className={styles.row}>
      {icon && <Block w="36px" h={36} />}
      <span className={styles.rowText}>
        <Block w="38%" h={14} />
      </span>
      <Block w="14px" h={14} />
    </span>
  );
}

/** 「我的」Tab 骨架：资料卡 + 三组设置行（行数对齐 MeTab 的 4/4/4 分组） */
export function MeTabSkeleton() {
  return (
    <div className={styles.mePage} data-testid="me-loading-shell" aria-busy="true">
      <span className={styles.meCard}>
        <Block w="56px" h={56} round />
        <span className={styles.meCardText}>
          <Block w="42%" h={17} />
          <Block w="30%" h={13} />
        </span>
      </span>
      {[4, 4, 4].map((n, gi) => (
        <span className={styles.group} key={gi}>
          {Array.from({ length: n }, (_, i) => (
            <Row key={i} icon />
          ))}
        </span>
      ))}
    </div>
  );
}

/** 通讯录骨架：头像 + 名字的扁平行 */
export function ContactsSkeleton() {
  return (
    <div className={styles.listPage} data-testid="contacts-loading-shell" aria-busy="true">
      {Array.from({ length: 10 }, (_, i) => (
        <span className={styles.row} key={i}>
          <Block w="40px" h={40} round />
          <span className={styles.rowText}>
            <Block w={`${30 + ((i * 7) % 25)}%`} h={14} />
          </span>
        </span>
      ))}
    </div>
  );
}

/**
 * 聊天时间线骨架（21aa）：左右交替的气泡占位。
 * 宽度刻意错落——等宽的几条看起来像表格而不像聊天。
 */
export function ChatSkeleton() {
  const rows = [62, 38, 50, 72, 44, 56, 34];
  return (
    <div className={styles.chatPage} data-testid="messages-loading" aria-busy="true">
      {rows.map((w, i) => (
        <span className={i % 3 === 1 ? styles.chatRowOut : styles.chatRow} key={i}>
          <span className={styles.bubble} style={{ width: `${w}%` }} />
        </span>
      ))}
    </div>
  );
}
